define([
	"dojo/_base/declare",
	"csi/heading/AttributeAction",
	"csi/xml"
], function(declare,AttributeAction,xml) {

	return declare(AttributeAction, {
		constructor: function(def) {
			this.m_id = "FileReset";
			this.classController = "csi.heading.FileResetController";
			this.confirmAction = "RESET";
		},

		hasAccess: function(/*csi.def.Context*/ctx) {
			// summary: check to make sure file exists before it can be reset
			return xml.isValidURL(this._getValue(ctx)) && this.inherited(arguments);
		}
	});
});